import Lozenge from '@atlaskit/lozenge';
import { borderRadius, colors, elevation, gridSize } from '@atlaskit/theme';
import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { redirect } from '../../facade/window';
import { AnalyticsConsumerProps, withAnalytics } from '../../hoc/withAnalytics';

export const Container = styled.a`
  display: flex;
  justify-content: space-between;
  transition: 0.5s all;
  max-width: 400px;
  ${elevation.e200}
  &:hover,
  &:focus {
    ${elevation.e400}
    text-decoration: none;
  }
  border: none;
  border-radius: ${borderRadius()}px;
  margin-bottom: 16px;
  padding: ${gridSize() * 2}px ${gridSize() * 3}px;
  background: ${colors.N0};
  cursor: pointer;
`;

const Details = styled.div`
  color: ${colors.N500};
`;

export const Title = styled.h5`
  margin-bottom: 5px;
  color: inherit;
  text-transform: none;
  font-size: 14px;
  font-weight: bold;
  line-height: 20px;
`;

export const Subtitle = styled.p`
  margin: 0 0 5px;
  font-size: 14px;
  line-height: 20px;
`;

export const Users = styled.p`
  margin: 0;
  color: ${colors.N200};
  font-size: 11px;
  line-height: 16px;
`;

type Props = {
  cloudId: string;
  productName: string;
  siteName: string;
  url: string;
  usersCount?: number;
} & AnalyticsConsumerProps;

class InterimJoinCard extends React.Component<Props> {
  handleClick = async (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();
    const { analytics, cloudId, productName, siteName, url } = this.props;
    await analytics.ui(
      'productCard',
      'clicked',
      {
        cloudId,
        joinable: true,
        product: productName,
        siteName,
        url,
      },
      { source: 'joinableSitesScreen' },
    );
    redirect(url);
  };

  render() {
    const { productName, siteName, usersCount, url } = this.props;
    return (
      <Container href={url} onClick={this.handleClick}>
        <Details>
          <Title>{productName}</Title>
          <Subtitle>{siteName}</Subtitle>
          {usersCount !== undefined && (
            <Users>
              <FormattedMessage
                {...messages.usersCount}
                values={{
                  count: usersCount,
                }}
              />
            </Users>
          )}
        </Details>
        <div>
          <Lozenge appearance="new">
            <FormattedMessage {...messages.join} />
          </Lozenge>
        </div>
      </Container>
    );
  }
}

export default withAnalytics(InterimJoinCard);

export const messages = defineMessages({
  join: {
    defaultMessage: 'Join',
    description: 'Label displayed on the lozenge, on interim home join site cards',
    id: 'uchi.interimHome.joinCard.join',
  },
  usersCount: {
    defaultMessage: '{count} users',
    description: 'Text saying how many users there are on the site, on interim home join site cards',
    id: 'uchi.interimHome.joinCard.usersCount',
  },
});
